<template>
  <div class="grid mt-1">
    <div class="col-12 field">
      <div class="flex justify-content-between align-items-center p-inputtext">
        <div>{{ $t('Expanded') }}</div>
        <InputSwitch v-model="properties.expanded"/>
      </div>
    </div>
    <div class="col-12 field">
      <div class="flex justify-content-between align-items-center p-inputtext">
        <div>{{ $t('Auto add') }}</div>
        <InputSwitch v-model="properties.autoAdd"/>
      </div>
    </div>
    <div class="col-12 field">
      <div class="flex justify-content-between align-items-center p-inputtext">
        <div>{{ $t('Show add on map') }}</div>
        <InputSwitch v-model="properties.addOnMap"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import {defineComponent} from "vue";

export default defineComponent({
  name: "MapGeocoderControlConfiguration",
  props: {
    customControl: {
      type: Object,
      required: true
    }
  },
  computed: {
    properties() {
      if (!this.customControl.properties) this.customControl.properties = {};
      return this.customControl.properties;
    },
  }
})
</script>

<style scoped lang="scss">

</style>
